import React from 'react';
import LoadingState from '../../../components/states/LoadingState';
import EmptyState from '../../../components/states/EmptyState';

const CoursesView = ({
  user,
  stats,
  courses,
  loading,
  setSelectedCourse,
  getModuleThumbnail,
  getCourseProgress,
}) => {
  let content;

  if (loading) {
    content = <LoadingState message="Carregando seus cursos..." />;
  } else if (courses.length === 0) {
    content = (
      <EmptyState
        title="Nenhum curso disponível"
        message="Novos cursos serão adicionados em breve!"
        icon={
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" />
            <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" />
          </svg>
        }
      />
    );
  } else {
    content = (
      <div className="modules-grid-modern">
        {courses.map(course => {
          // Pega o primeiro módulo para a thumbnail
          const firstModule = course.modules?.[0];
          const thumbnail = firstModule ? getModuleThumbnail(firstModule) : null;

          return (
            <div key={course.id} className="course-card-container">
              <div className="course-card">
                {/* Course Thumbnail */}
                {thumbnail ? (
                  <div className="course-card-thumbnail">
                    <img src={thumbnail} alt={course.title} />
                    <div className="course-card-overlay"></div>
                  </div>
                ) : (
                  <div className="course-card-thumbnail course-card-thumbnail-placeholder">
                    <div className="course-card-icon">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" />
                        <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" />
                      </svg>
                    </div>
                  </div>
                )}

                {/* Course Content */}
                <div className="course-card-content">
                  <h3 className="course-card-title">{course.title}</h3>
                  <p className="course-card-description">{course.description}</p>

                  {/* Progress */}
                  <div className="course-card-progress">
                    <div className="progress-bar-container">
                      <div className="progress-bar-track">
                        <div
                          className="progress-bar-fill"
                          style={{
                            width: `${getCourseProgress(course.id)}%`,
                          }}
                        ></div>
                      </div>
                    </div>
                    <span className="progress-text">{getCourseProgress(course.id)}%</span>
                  </div>

                  <div className="course-card-meta">
                    <span className="course-meta-item">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />
                        <rect x="9" y="9" width="6" height="6" />
                      </svg>
                      {course.modules?.length || 0} módulos
                    </span>
                    <span className="course-meta-separator">•</span>
                    <span className="course-meta-item">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      Matriculado
                    </span>
                  </div>
                </div>

                {/* Course Actions */}
                <div className="course-card-actions">
                  <button onClick={() => setSelectedCourse(course)} className="btn btn-primary">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12,5 19,12 12,19" />
                    </svg>
                    Ver Módulos
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="courses-view-wrapper">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Bem-vindo de volta, <span className="hero-name">{user?.firstName}! 👋</span>
          </h1>
          <p className="hero-subtitle">
            Continue sua jornada de aprendizado com nossos cursos modernos e interativos
          </p>
        </div>

        {/* Quick Stats */}
        <div className="quick-stats">
          <div className="stat-item">
            <div className="stat-value">{stats.totalModules}</div>
            <div className="stat-label">Módulos</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{stats.completedLessons}</div>
            <div className="stat-label">Aulas Concluídas</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{stats.progressPercentage}%</div>
            <div className="stat-label">Progresso</div>
          </div>
        </div>
      </div>

      {/* Courses Section */}
      <div className="courses-section">
        <div className="section-header-modern">
          <div>
            <h2 className="section-title-modern">Meus Cursos</h2>
            <p className="section-description">Explore os cursos disponíveis</p>
          </div>
        </div>

        {content}
      </div>
    </div>
  );
};

export default CoursesView;
